import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { storage } from "../config/firebase";

export const MAX_CHAT_IMAGE_BYTES = 10 * 1024 * 1024;

// Returns an error message if the file is not an acceptable chat image, otherwise null.
export function validateChatImage(file) {
  if (!file) return "No image selected";
  if (!file.type || !file.type.startsWith("image/")) return "Please select a valid image file";
  if (file.size > MAX_CHAT_IMAGE_BYTES) return "Image must be smaller than 10MB";
  return null;
}

// Uploads a chat image to Firebase Storage under the shop/conversation folder and resolves to its public download URL.
export async function uploadChatImage(file, shopId, docid) {
  const extension = (file.name && file.name.includes(".")) ? file.name.split(".").pop() : "jpg";
  const storagePath = `chat-images/${shopId}/${docid}/${Date.now()}.${extension}`;
  const imageRef = ref(storage, storagePath);
  await uploadBytes(imageRef, file, { contentType: file.type || "image/jpeg" });
  return getDownloadURL(imageRef);
}
